export enum DeleteDonorReason {
    Other = 1,
    MedicallyUnsuitable = 2,
    NoTimeOffWork = 3,
    DonorBackedOut = 4,
    RecipientReceivedDeceasedXplant = 5,
    RecipientInAnotherSwap = 6,
    UnableToContact = 7
}

export const deleteDonorReasonList = [
    { id: DeleteDonorReason.Other, description: 'Other' },
    { id: DeleteDonorReason.MedicallyUnsuitable, description: 'Donor became medically unsuitable' },
    { id: DeleteDonorReason.NoTimeOffWork, description: 'Donor could not get time off work' },
    { id: DeleteDonorReason.DonorBackedOut, description: 'Donor backed out' },
    { id: DeleteDonorReason.RecipientReceivedDeceasedXplant, description: 'Recipient received deceased donor transplant' },
    { id: DeleteDonorReason.RecipientInAnotherSwap, description: 'Recipient transplanted in another swap' },
    { id: DeleteDonorReason.UnableToContact, description: 'Kidney for Life Remote' },
];